module.exports = __webpack_public_path__ + "img/upperabs-ecto-mesomorph-female.97af5c7b.svg";